import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormStyled } from './Form.styled';

interface Props {
  title: string;
  message: string;
  link?: string;
  a?: string;
  to?: any;
}

export const Messageform = (props: Props) => {
  const { t } = useTranslation();

  return (
    <FormStyled.Wrapper>
      <FormStyled.Title>{t(props.title)}</FormStyled.Title>
      <FormStyled.Message>{t(props.message)}</FormStyled.Message>
      {props.a && props.link && (
        <FormStyled.LinkExternalCustom href={props.a}>
          {t(props.link)}
        </FormStyled.LinkExternalCustom>
      )}
      {props.to && props.link && (
        <FormStyled.LinkCustom to={props.to}>
          {props.link && t(props.link)}
        </FormStyled.LinkCustom>
      )}
    </FormStyled.Wrapper>
  );
};
